<script>
    import { db, functions, break_session, user } from '../stores.js';
    export let time = 0;
    let highlightClips = [];
    const totalClips = 5;
    let addBtn;
    let status = "";

    function addClip(){
        let timeClicked = time - 3;
        addBtn.disabled = true;
        if (timeClicked < 0){
            timeClicked = 0;
        }
        console.log("add a clip", timeClicked);
        highlightClips = [...highlightClips, timeClicked];
        if (highlightClips.length < 5){
            window.setTimeout(() => {addBtn.disabled = false}, 5*1000);  
        }

    }

    function createHighlightVideo(){
        console.log("createHighlightVideo");
        addBtn.disabled = true;
        status = "saving...";
        $db.collection("highlights").doc($break_session.id).collection("clips").doc($user.uid).set({
            timestamps: highlightClips,
            username: $user.username,
            status: "submitted"
        },{ merge: true}).then(() => {
            console.log("Timestamps successfully saved");
            $db.collection("users").doc($user.uid).set({
                highlightStatus: "submitted"
            },{ merge: true}).then(() => {
                console.log("highlightStatus successfully updated");
                status = "saved. You will be notified when your highlight video is ready.";
            }).catch((error) => {
                console.error("Error updating highlightStatus", error);
                status = "Error updating highlightStatus";
            });
        }).catch((error) => {
            console.error("Error saving timestamps", error);
            status = "Error saving timestamps";
        });


    }
</script>

<!-- highlights generator goes here 
<br/>{time} -->
<br/><button on:click={addClip} disabled={highlightClips.length === totalClips} bind:this={addBtn}>add a clip ({highlightClips.length}/{totalClips})</button>
<button on:click={createHighlightVideo} disabled={highlightClips.length === 0}>create a highlights video</button>
<br/>{status}
<style>
    button {
        cursor: pointer;
    }
</style>